module.exports = __webpack_public_path__ + "img/mushamaru_4.026cb97c.png";